import { CustomError } from '@kulee/helper'
import { RESPONSE_CODES } from '@kulee/tga-constant'
import BaseModule from '../../BaseModule'
import logger from '../../config/logger'
import type { BusinessOrder, PayOrder } from '../../types/wallet'
import WalletService from './Service'

class Wallet extends BaseModule {
  public static override clazz = 'Wallet'

  public service!: WalletService

  public override run(): void {
    logger.log(`run module ${Wallet.clazz}`)

    this.service = new WalletService(this.context)
  }

  /**
   * 支付
   * @param order 订单信息
   * @returns 支付订单
   */
  public async pay(order: BusinessOrder): Promise<PayOrder> {
    const { paymentCode, payOrderNo } = order

    if (paymentCode === 'DIAMOND_PAY') {
      const { data } = await this.service.pay({
        payOrderNo,
        paymentCode
      })
      return data
    } else if (paymentCode === 'GOOGLE_PAY') {
      return this.googleKuleWebviewPay(order)
    } else if (paymentCode === 'BIP_PAY') {
      return this.bipKuleWebviewPay(order)
    }

    throw new CustomError({ code: 'ERROR---1' })
  }

  /**
   * 谷歌内购支付
   * @param options 订单信息
   * @returns 支付订单
   */
  private async googleKuleWebviewPay(options: BusinessOrder): Promise<PayOrder> {
    const { payOrderNo, payExternalParam } = options
    if (!payExternalParam || payExternalParam['sku'] === undefined) {
      throw new CustomError({
        code: RESPONSE_CODES.PARAMETER_INVALID
      })
    }

    const { isSuccess } = await window.Bridge.wallet.pay({
      type: 'google',
      data: {
        order: payOrderNo,
        sku: payExternalParam['sku']
      }
    })

    if (isSuccess === 1) {
      const { data } = await this.service.getPayOrderDetail(payOrderNo)
      return data
    }

    throw new CustomError({
      code: RESPONSE_CODES.WALLET_PAY_FAILED,
      message: RESPONSE_CODES.WALLET_PAY_FAILED
    })
  }

  /**
   * BIP内购支付
   * @param options 订单信息
   * @returns 支付订单
   */
  private async bipKuleWebviewPay(order: BusinessOrder): Promise<PayOrder> {
    const { payOrderNo, amount, payExternalParam } = order
    // bip需要唯一的transactionId，按内部约定规则进行转换
    const date = new Date()
    const transactionId = payOrderNo.replace(
      /^\w{2}\d{2}/,
      date.getMinutes().toString().padStart(2, '0') + date.getSeconds().toString().padStart(2, '0')
    )

    const res = await window.Bridge.wallet.pay({
      type: 'bip',
      data: {
        order: {
          // --bip方提供--
          paymentMethod: 'reserve',
          // 暂时关闭
          // wsuser: '',
          // password: '',
          channelId: 50,
          isDeliverable: true,
          // --bip方提供--
          transactionId,
          amount,
          payStatus: 0,
          deliverStatus: 0,
          description: order.commodity?.desc || '',
          itemList: [{ count: 1, id: payExternalParam['id'], name: payExternalParam['sku'] }]
        }
      }
    })

    if (res.isSuccess === 1) {
      const { data } = await this.service.getPayOrderDetail(payOrderNo)
      return data
    }

    let mes = ''
    try {
      mes = JSON.stringify(res)
    } catch (error) {}

    throw new CustomError({
      code: `ERROR---2--${mes}--${res.isSuccess}`
    })
  }
}

export default Wallet
